import { useLanguage } from '../i18n/LanguageContext';
import { destinations } from '../data/destinations';

export const Marquee = () => {
  const { lang } = useLanguage();
  const items = [...destinations.map((d) => d.name[lang]), 'Your Journey, Your Way.'];
  const row = [...items, ...items];

  return (
    <div className="overflow-hidden border-y border-navy/10 bg-gold py-5" data-testid="editorial-marquee">
      <div className="marquee-track items-baseline gap-24 pr-24">
        {row.map((item, i) => (
          <span key={i} className="flex items-baseline gap-24 whitespace-nowrap">
            <span className="font-heading text-2xl italic text-navy md:text-3xl">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-navy/60" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
